module.exports = __webpack_public_path__ + "img/AntikorMono-News.372f822c.svg";